import { ClosedPeriodResponse } from "../contracts/ClosedPeriodResponse";
import { ClosedPeriod } from "../models/ClosedPeriod";

export const mapResponseToClosedPeriod = (resp: ClosedPeriodResponse): ClosedPeriod => ({
  id: resp.id,
  memberId: resp.memberId,
  scope: resp.scope,
  cause: resp.cause,
  treatment: resp.treatment,
  startDate: resp.startDate,
  endDate: resp.endDate,
  reducedAmountMinorUnits: resp.reducedAmountMinorUnits,
  notes: resp.notes,
  dateCreated: resp.dateCreated,
  dateModified: resp.dateModified,
});
